/* @flow */

import { List } from 'immutable'

export type MetaType = { step?: string, field?: string }
type DocumentsListType = List<Map<string, any>>
type SecondFuncType = (search: MetaType) => DocumentsListType

export const findDocuments = (documents?: DocumentsListType): SecondFuncType => (
  search: MetaType
): DocumentsListType => {
  documents = documents || List([])
  const searchkeys = Object.keys(search)
  return documents.filter((doc) => {
    return searchkeys.every((key) => {
      return doc.get(key) == search[key]
    })
  })
}
